<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Discounts Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Discounts Report",
      items: [
        {
          text: "Reports Section",
          href: "#/",
        },
        {
          text: "Discounts Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "patient.patient_name",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "patient.patient_contact",
          sortable: true,
          label: "PATIENT CONTACT",
        },
        {
          key: "visit_date",
          sortable: true,
          label: "VISIT DATE",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "user.name",
          sortable: true,
          label: "STAFF",
        },
        {
          key: "created_at",
          sortable: true,
          label: "DISCOUNT DATE",
        },
      ],
      fitered_array: [],
      filterreport: {
        title: "DISCOUNTS REPORT",
        today: moment(new Date()).format("YYYY-MM-DD"),
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        staff: "",
      },
      // FILTER

      rep_totals: {
        total_amount: "",
        total_discount: "",
      },
      //   ============================= EXPORT ==============================
      json_fields: {
        NAME: "patient.patient_name",
        BRANCH: "branch",
        PATIENT_CONTACT: "patient.patient_contact",
        VISIT_DATE: "visit_date",
        DISCOUNT: "amount",
        DISCOUNT_DATE: "created_at",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("reports", ["DiscountReport"]),
    ...mapGetters("users", ["CLINIC_USERS"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    DiscountReport(newValue) {
      if (newValue.length > 0) {
        this.discount_reportData();
      }
    },
  },
  methods: {
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    discount_reportData() {
      this.fitered_array = this.DiscountReport;
    },

    ...mapActions({
      FetchDiscountReport: "reports/fetchDiscountReport",
      FetchUsers: "users/fetchUsers",
    }),

    filter_report() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let staff = this.filterreport.staff;
      if (startDate != "" && endDate != "" && staff == "") {
        this.filterreport.title =
          "DISCOUNTS REPORT FROM " +
          this.filterreport.date1 +
          " TO " +
          this.filterreport.date2;
        this.fitered_array = this.DiscountReport.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate;
        });
      } else if (startDate != "" && endDate != "" && staff != "") {
        this.filterreport.title =
          "DISCOUNTS REPORT FROM " +
          this.filterreport.date1 +
          " TO " +
          this.filterreport.date2;
        this.fitered_array = this.DiscountReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.user_id == staff
          );
        });
      } else if (startDate == "" && endDate != "" && staff == "") {
        this.fitered_array = this.DiscountReport.filter((pymts) => {
          return pymts.filter_date <= endDate;
        });
      } else if (startDate == "" && endDate != "" && staff != "") {
        this.fitered_array = this.DiscountReport.filter((pymts) => {
          return pymts.filter_date <= endDate && pymts.user_id == staff;
        });
      }

      let total_discount = 0;
      this.fitered_array.forEach((value) => {
        var discount1 = value.discount_no;
        total_discount = total_discount + parseInt(discount1);
      });
      this.rep_totals.total_discount = this.thousandSeprator(total_discount);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.discount_reportData();
    this.FetchDiscountReport();
    this.FetchUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title mb-2 text-center" v-html="filterreport.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>STAFF</label>
                <model-list-select
                  @input="filter_report()"
                  :list="CLINIC_USERS ? CLINIC_USERS : []"
                  v-model="filterreport.staff"
                  option-value="id"
                  option-text="name"
                  placeholder="select Staff"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="fitered_array"
                  :fields="json_fields"
                  :worksheet="'DISCOUNTS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Discounts_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
              <center>
                <h3 v-if="!DiscountReport" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
